import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_3 = { class: "card-header d-flex justify-content-between align-items-center" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "card-body p-9" }
const _hoisted_8 = { class: "mb-10" }
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = { class: "d-flex flex-wrap py-5" }
const _hoisted_11 = { class: "flex-equal me-5" }
const _hoisted_12 = { class: "table fs-6 fw-bold gs-0 gy-2 gx-2 m-0" }
const _hoisted_13 = { class: "text-gray-400 min-w-175px" }
const _hoisted_14 = { class: "text-gray-800" }
const _hoisted_15 = { class: "text-gray-400" }
const _hoisted_16 = { class: "text-gray-800" }
const _hoisted_17 = { class: "text-gray-400" }
const _hoisted_18 = { class: "text-gray-800" }
const _hoisted_19 = { class: "text-gray-400" }
const _hoisted_20 = { class: "text-gray-800" }
const _hoisted_21 = { class: "flex-equal" }
const _hoisted_22 = { class: "table fs-6 fw-bold gs-0 gy-2 gx-2 m-0" }
const _hoisted_23 = { class: "text-gray-400" }
const _hoisted_24 = { class: "text-gray-800" }
const _hoisted_25 = { class: "text-gray-400" }
const _hoisted_26 = { class: "text-gray-800" }
const _hoisted_27 = { class: "text-gray-400" }
const _hoisted_28 = { class: "text-gray-800" }
const _hoisted_29 = { class: "card mt-10" }
const _hoisted_30 = { class: "card-header" }
const _hoisted_31 = { class: "card-title" }
const _hoisted_32 = { class: "fw-bolder" }
const _hoisted_33 = { class: "card-body pt-5" }
const _hoisted_34 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_35 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("th", null, "#", -1)
const _hoisted_37 = ["href"]
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = {
  colspan: "5",
  class: "text-center text-gray-400"
}
const _hoisted_41 = { class: "d-flex justify-content-between align-items-center mt-4" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.can('read', 'payments') && _ctx.promo)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.translate('promotionDetails')), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: "btn btn-light me-3",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, _toDisplayString(_ctx.translate('backToList')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h5", _hoisted_9, _toDisplayString(_ctx.translate('usageSummary')) + ":", 1),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("table", _hoisted_12, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.translate('promoCode')) + ": ", 1),
                      _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.promo.promoCode), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.translate('allowedUsage')) + ": ", 1),
                      _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.promo.allowedUsage), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.translate('usedCount')) + ":", 1),
                      _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.promo.actualUsage), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.translate('remainingUses')) + ": ", 1),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.promo.allowedUsage - _ctx.promo.actualUsage), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("table", _hoisted_22, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.translate('status')) + ":", 1),
                      _createElementVNode("td", _hoisted_24, [
                        _createElementVNode("span", {
                          class: _normalizeClass(`badge ${
                        _ctx.promo.isActive
                          ? 'badge-light-success'
                          : 'badge-light-danger'
                      } text-uppercase`)
                        }, _toDisplayString(_ctx.promo.isActive
                          ? _ctx.translate('active')
                          : _ctx.translate('inactive')), 3)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.translate('createdAt')) + ":", 1),
                      _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.promo.publishAt), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.translate('expiryAt')) + ":", 1),
                      _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.promo.expiryAt), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("h2", _hoisted_32, _toDisplayString(_ctx.translate('users') + ' (' + _ctx.employeeCount + ')'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("table", _hoisted_34, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_35, [
                      _hoisted_36,
                      _createElementVNode("th", null, _toDisplayString(_ctx.translate('name')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.translate('email')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.translate('phone')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.translate('paidAmount')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.translate('purchaseAt')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.translate('status')), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employees, (employee, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: employee.id
                      }, [
                        _createElementVNode("td", null, _toDisplayString((_ctx.currentPage - 1) * _ctx.pageSize + index + 1), 1),
                        _createElementVNode("td", null, _toDisplayString(employee.name ?? employee.members?.name ?? '-'), 1),
                        _createElementVNode("td", null, [
                          (employee.members?.email)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: `mailto:${employee.members?.email}`,
                                class: "text-hover-primary"
                              }, _toDisplayString(employee.email ?? employee.members?.email), 9, _hoisted_37))
                            : (_openBlock(), _createElementBlock("span", _hoisted_38, "-"))
                        ]),
                        _createElementVNode("td", null, _toDisplayString(employee.members?.phone), 1),
                        _createElementVNode("td", null, _toDisplayString(employee?.paidAmount), 1),
                        _createElementVNode("td", null, _toDisplayString(employee?.purchaseAt), 1)
                      ]))
                    }), 128)),
                    (_ctx.employees.length === 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_39, [
                          _createElementVNode("td", _hoisted_40, _toDisplayString(_ctx.translate('noUsersFound')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("button", {
                    class: "btn btn-light",
                    disabled: _ctx.currentPage === 1,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onPageChange('previous')))
                  }, _toDisplayString(_ctx.translate('previous')), 9, _hoisted_42),
                  _createElementVNode("div", null, _toDisplayString(_ctx.translate('page')) + " " + _toDisplayString(_ctx.currentPage) + " " + _toDisplayString(_ctx.translate('of')) + " " + _toDisplayString(Math.ceil(_ctx.totalItems / _ctx.pageSize)), 1),
                  _createElementVNode("button", {
                    class: "btn btn-light",
                    disabled: !_ctx.isNext,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onPageChange('next')))
                  }, _toDisplayString(_ctx.translate('next')), 9, _hoisted_43)
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}